import React from "react";
import PhotoPageStateProvider from "pages/photo/state";

import CategoriesProvider from "features/firebase/categories/CategoriesProvider";
import BrandsProvider from "features/firebase/brands/BrandsProvider";

import PhotoPageSubRouter from "./routes/SubRouter";

export default function PhotoRoute() {
  return (
    <PhotoPageStateProvider>
      <CategoriesProvider>
        <BrandsProvider>
          <PhotoPageSubRouter />
        </BrandsProvider>
      </CategoriesProvider>
    </PhotoPageStateProvider>
  );
}
